export default "__VITE_ASSET__UBCOK59c__"